/**
 * Convert a #rrggbb (or rrggbb) hex color + 0..100 opacity into an rgba()
 * string. Opacity is clamped to [0,100]. Non-hex input (named colors, existing
 * rgba) is returned unchanged so callers can pass it through safely.
 */
export function colorWithOpacity(hex: string, opacityPct: number): string {
  const a = Math.max(0, Math.min(100, opacityPct)) / 100;
  const m = /^#?([0-9a-fA-F]{6})$/.exec(hex.trim());
  if (!m) return hex;
  const n = parseInt(m[1], 16);
  const r = (n >> 16) & 255;
  const g = (n >> 8) & 255;
  const b = n & 255;
  return `rgba(${r}, ${g}, ${b}, ${a})`;
}
